<template>
  <el-row :gutter="10">
    <el-col :xl="19" :lg="19" :md="15" :sm="24">
      <div class="searchForm" :class="showLabel ? 'p-3 mt-2' : ''">
        <label for="search" v-if="showLabel">اختر اسم العميل</label>
        <el-row :gutter="10">
          <el-col
            :xl="24"
            :lg="24"
            :md="15"
            :sm="24"
            style="position: relative;"
          >
            <input
              type="text"
              @focus="resetSearch"
              class="form-control"
              readonly
              v-model="placeholder"
              id=""
              v-if="selectedCustomer"
            />
            <el-select
              v-else
              @change="customerSelected"
              class="search customerQuery"
              @focus="options = []"
              v-model="value"
              :loading-text="loadingMsg"
              :no-data-text="noDataMsg"
              filterable
              popper-class="searchDropdown"
              remote
              :clearable="true"
              :placeholder="placeholder"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                ref="customerQuery"
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span style="float: right">
                  {{ item.name }} - {{ item.address }}</span
                >
              </el-option>
              <el-option v-if="accessLinks('add_new_customer')" value="0">
                
                <el-button
                  v-if="addCustomer"
                  class="addCustomer"
                  @click="handleSearchEnter"
                  >إضافة عميل جديد</el-button
                >
              </el-option>
            </el-select>
          </el-col>
          <!-- <el-col
            v-if="accessLinks('add_new_customer') && selectedCustomer == null"
            :xl="6"
            :lg="6"
            :md="15"
            :sm="24"
          >
            <el-button
              v-if="addCustomer"
              type="success"
              plain
              @click="handleSearchEnter"
              >إضافة عميل جديد</el-button
            >
          </el-col> -->
        </el-row>
      </div>
    </el-col>

    <el-col
      v-if="selectedCustomer && searchOnly == false"
      :xl="5"
      :lg="5"
      :md="7"
      :sm="24"
      ><div class="bg-White result mt-2">
        <p>
          <span class="num" v-if="customerAccount >= 0">{{
            numberToFixed(Number(customerAccount))
          }}</span>
          <span class="num" v-else>{{
            numberToFixed(Number(customerAccount) * -1)
          }}</span>
          <br />
          <span v-if="customerAccount >= 0">مدين</span>
          <span v-else>دائن</span>
        </p>
      </div></el-col
    >

    <el-dialog
      title="تسجيل عميل جديد"
      :visible.sync="addFormVisible"
      v-if="customerForm"
    >
      <el-form :model="customerForm" :rules="rules" ref="customerForm">
        <el-row :gutter="10">
          <el-col :xl="12" :lg="12" :md="6" :sm="12">
            <el-form-item label="الاسم " prop="name">
              <el-input
                class="formInput1"
                autofocus
                v-model="customerForm.name"
                autocomplete="off"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
            <!-- @focus="$event.target.select()" -->
          </el-col>
          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-form-item label="رصيد العميل " prop="account">
              <el-input
                class="formInput2"
                id="account"
                type="number"
                @focus="$event.target.select()"
                v-model="customerForm.account"
                controls-position="right"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-form-item label="نوع التسعير " prop="price_type">
              <el-select
                id="priceType"
                @change="focusNext"
                @focus="$event.target.select()"
                class="mt-2 formInput3"
                v-model="customerForm.price_type"
                clearable
                placeholder=" نوع التسعير"
                style="width: 100%"
              >
                <el-option label="جمله" value="2"> </el-option>
                <el-option label="جملة الجملة" value="1"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="24" :sm="24">
            <el-form-item label="رقم الهاتف 1 " prop="phone">
              <el-input
                class="formInput4"
                id="phone"
                @focus="$event.target.select()"
                v-model="customerForm.phone"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="24" :sm="24">
            <el-form-item label="رقم الهاتف 2 " prop="shop_phone">
              <el-input
                class="formInput4"
                id="shop_phone"
                @focus="$event.target.select()"
                v-model="customerForm.shop_phone"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="24" :sm="24">
            <el-form-item label="العنوان  " prop="address">
              <el-input
                class="formInput5"
                id="address"
                @focus="$event.target.select()"
                v-model="customerForm.address"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="addNewCustomer"
          >تسجيل العميل
        </el-button>
        <el-button class="mr-3" @click="addFormVisible = false"
          >إلغاء</el-button
        >
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  name: "SearchCustomers",
  props: [
    "productsLength",
    "customer",
    "productSearch",
    "searchOnly",
    "showLabel",
    "useParcode",
  ],

  data() {
    return {
      right: 0,
      rules: {
        index: 1,

        name: [{ required: true, message: "حدد اسم العميل", trigger: "blur" }],
        account: [
          { required: true, message: "حدد الرصيد الافتتاحي", trigger: "blur" },
        ],
        price_type: [
          { required: true, message: "حدد سياسة التسعير ", trigger: "blur" },
        ],
        address: [{ required: true, message: "حدد العنوان ", trigger: "blur" }],
        phone: [
          { required: true, message: "حدد رقم الهاتف", trigger: "blur" },
          { min: 11, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
        ],
        shop_phone: [
          { min:1, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
        ],
      },
      selectedLabel: "",
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      value: null,
      loading: false,
      placeholder: this.customer ? this.customer.name : "بحث العملاء",
      selectedCustomer: this.customer,
      customerAccount: this.customer
        ? Number(this.customer.balance) + Number(this.customer.account)
        : 0,
      addFormVisible: false,
      addCustomer: false,
      customerForm: {
        name: "",
        type: "1",

        inventory_id: 1,
        area: 1,
        phone: "",
        shop_phone: "",
        account: 0,
        price_type: "1",
        supplier_account: 0,
        address: "",
      },
    };
  },
  mounted() {
    if (this.selectedCustomer) {
      this.placeholder = this.selectedCustomer.name;
    }
    if (this.selectedCustomer) {
      document.querySelector(".productQuery input").focus();
    } else {
      document.querySelector(".customerQuery input").focus();
    }
    if (this.$route.name != "ReturnSale") {
      this.addCustomer = true;
    }
  },
  methods: {
    setValue(value) {
      this.selectedCustomer = value;
      this.value = value;
      if (this.value != null) {
        this.placeholder = value.name;
        this.customerAccount = Number(value.balance) + Number(value.account);
      } else {
        this.placeholder = "بحث العملاء";
        this.customerAccount = 0;
      }
      if (this.value) {
        setTimeout(() => {
          document.querySelector(".productQuery input").focus();
        }, 100);
      } else {
        setTimeout(() => {
          document.querySelector(".customerQuery input").focus();
        }, 100);
      }
    },
    resetSearch() {
      if (this.productsLength == 0) {
        this.setValue(null);
        this.$emit("selectedCustomer", {
          customer: this.selectedCustomer,
        });
      }
    },
    customerSelected() {
      if (this.value != "0") {
        console.log("customerSelected", this.value);
        this.selectedCustomer = this.options.filter((customer) => {
          if (customer.id == this.value) {
            return customer;
          }
        })[0];
        if (this.selectedCustomer) {
          this.placeholder = this.selectedCustomer.name;
          this.customerAccount =
            Number(this.selectedCustomer.balance) + Number(this.selectedCustomer.account);
          setTimeout(() => {
            if (!this.useParcode) {
              document.querySelector(".productQuery input").focus();
            } else {
              document.querySelector(".parcodeSearch input[type='text']").focus();
            }
          }, 100);
        }
        this.$emit("selectedCustomer", {
          customer: this.selectedCustomer,
        });
      } else {
        this.value = "";
        this.handleSearchEnter();
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectedLabel = query;
        this.loading = true;
        axiosApi
          .get(`customers/search?query=${query}`)
          .then((res) => {
            this.loading = false;
            this.options = res.data;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      } else {
        this.options = [];
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    handleSearchEnter() {
      this.customerForm.name = this.selectedLabel;
      this.customerForm.phone = "";
      this.customerForm.account = 0;
      // alert("new")
      this.addFormVisible = true;
      setTimeout(() => {
        document.querySelector(".formInput1 input").focus();
      }, 100);
    },
    addNewCustomer() {
      this.$refs["customerForm"].validate((valid) => {
        if (valid) {
          axiosApi
            .post("customers", this.customerForm)
            .then((res) => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });
              this.addFormVisible = false;
              this.selectedCustomer = res.data;
              this.placeholder = res.data.name;
              this.customerAccount = Number(res.data.balance) + Number(res.data.account);
              this.value = res.data.id;
              this.$emit("selectedCustomer", {
                customer: this.selectedCustomer,
              });
              this.index = 1;
              this.selectedLabel = "";
              this.$refs["customerForm"].resetFields();
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا رقم الهاتف مستخدم لحساب اخر ",
                type: "error",
                duration: 1500,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    focusNext() {
      if (this.index < 5) {
        this.index += 1;
      } else {
        this.index = 1;
      }
      let input = ".formInput" + this.index + " input";
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },
    accessLinks(link) {
      let menu = JSON.parse(localStorage.getItem("permissionNames"));
      return menu.includes(link);
    }
  },
};
</script>

<style lang="scss">
.addCustomer {
  background-color: transparent;
  border: none;
  outline: none;
  width: 100%;
}
</style>
